import useMemoryState from "../../hooks/memoryStateHook"
import { genericDelete, genericGet, genericPost, genericUpdate, genericGetWithProcessor, CONFIGURATIONS_EXTENSION, MACHINES_EXTENSION, FORNECEDORES_EXTENSION, CLIENTS_EXTENSION, generalObjectBuilder, MATERIAIS_EXTENSION, DISPOSITIVOS_MEDICAO_EXTENSION } from "../../services/api.service"
import TableView from "../Common/TableView"
import { ClientsFornecedoresTableConfig, DispositivoMedicaoConfigs, MachinesTableConfig, MaterialTableConfig, NotificationsTableConfigs } from "./Configuration.config"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';


export default function Configuration() {


  const [tab, setTab] = useMemoryState('c-tab', 0)



  return (<div>


    {/* TODO put this back on Tabs variant='soft-rounded'*/}
    <div style={{ margin: 20 }}>
      <Tabs selectedIndex={tab} onSelect={(index) => setTab(index)}>
        <TabList>
          <Tab>Clientes</Tab>
          <Tab>Fornecedores</Tab>
          <Tab>Máquinas</Tab>
          <Tab>Materiais</Tab>
          <Tab>Dispositivos de Medição</Tab>
          <Tab>Configurações Notificações</Tab>

        </TabList>

        <TabPanel>
          {tab == 0 ? <>
            <h2 style={{ margin: '40px' }}>Clientes</h2>
            <TableView
              postEntity={genericPost(CLIENTS_EXTENSION)}
              editEntity={genericUpdate(CLIENTS_EXTENSION)}
              deleteEntity={genericDelete(CLIENTS_EXTENSION)}
              addButtonText={"Novo Cliente"}
              tableConfigs={ClientsFornecedoresTableConfig}
              entityName={"Clientes"}
              dataBuildFunction={generalObjectBuilder(ClientsFornecedoresTableConfig)}
              idProp={"number"}
              disableDensePadding={true}
              configMapKey={'clients'}
              reroute={true}
            />

          </> : null}

        </TabPanel>
        <TabPanel>
          {tab == 1 ? <>
            <h2 style={{ margin: '40px' }}>Fornecedores</h2>
            <TableView
              postEntity={genericPost(FORNECEDORES_EXTENSION)}
              editEntity={genericUpdate(FORNECEDORES_EXTENSION)}
              deleteEntity={genericDelete(FORNECEDORES_EXTENSION)}
              addButtonText={"Novo Fornecedor"}
              tableConfigs={ClientsFornecedoresTableConfig}
              entityName={"Fornecedores"}
              dataBuildFunction={generalObjectBuilder(ClientsFornecedoresTableConfig)}
              idProp={"number"}
              disableDensePadding={true}
              configMapKey={'fornecedores'}
              reroute={true}

            />

          </> : null}

        </TabPanel>

        <TabPanel>
          {tab == 2 ? <>
            <h2 style={{ margin: '40px' }}>Máquinas</h2>
            <TableView
              postEntity={genericPost(MACHINES_EXTENSION)}
              editEntity={genericUpdate(MACHINES_EXTENSION)}
              deleteEntity={genericDelete(MACHINES_EXTENSION)}
              addButtonText={"Nova Máquina"}
              tableConfigs={MachinesTableConfig}
              entityName={"Máquinas"}
              dataBuildFunction={generalObjectBuilder(MachinesTableConfig)}
              idProp={"number"}
              disableDensePadding={true}
              configMapKey={'machines'}
              reroute={true}

            />

          </> : null}

        </TabPanel>

        <TabPanel>
          {tab == 3 ? <>
            <h2 style={{ margin: '40px' }}>Materiais</h2>
            <TableView
              postEntity={genericPost(MATERIAIS_EXTENSION)}
              editEntity={genericUpdate(MATERIAIS_EXTENSION)}
              deleteEntity={genericDelete(MATERIAIS_EXTENSION)}
              addButtonText={"Novo Material"}
              tableConfigs={MaterialTableConfig}
              entityName={"Materiais"}
              dataBuildFunction={generalObjectBuilder(MaterialTableConfig)}
              idProp={"reference"}
              disableDensePadding={true}
              configMapKey={'materiais'}
              reroute={true}
              specificRoute={'/materiais'}
            />
          </> : null}

        </TabPanel>

        <TabPanel>
          {tab == 4 ? <>
            <h2 style={{ margin: '40px' }}>Dispositivos de Medição</h2>
            <TableView
              postEntity={genericPost(DISPOSITIVOS_MEDICAO_EXTENSION)}
              editEntity={genericUpdate(DISPOSITIVOS_MEDICAO_EXTENSION)}
              deleteEntity={genericDelete(DISPOSITIVOS_MEDICAO_EXTENSION)}
              tableConfigs={DispositivoMedicaoConfigs}
              entityName={"Dispositivos de Medição"}
              dataBuildFunction={generalObjectBuilder(DispositivoMedicaoConfigs)}
              idProp={"number"}
              disableDensePadding={true}
              configMapKey={'dispositivo-medicao'}
              reroute={true}
              specificRoute={'/dispositivo-medicao'}
            />
          </> : null}

        </TabPanel>

        <TabPanel>
          {tab == 5 ? <>
            <h2 style={{ margin: '40px' }}>Configurações Notificações</h2>
            <TableView
              postEntity={genericPost(CONFIGURATIONS_EXTENSION)}
              editEntity={genericUpdate(CONFIGURATIONS_EXTENSION)}
              deleteEntity={genericDelete(CONFIGURATIONS_EXTENSION)}
              tableConfigs={NotificationsTableConfigs}
              entityName={"Configuração"}
              dataBuildFunction={generalObjectBuilder(NotificationsTableConfigs)}
              idProp={"number"}
              disableDensePadding={true}
              configMapKey={'notificacoes/configurations'}
              reroute={true}
              specificRoute={'/notificacoes/configurations'}
            />
          </> : null}

        </TabPanel>


      </Tabs>
    </div>














  </div>)

}